(() => {
  if (window.__MF_METALLIC_V7_LOADER__) return;
  window.__MF_METALLIC_V7_LOADER__ = true;

  const base = document.currentScript?.src || location.href;
  let started = false;
  let tries = 0;

  const markMetallicHosts = () => {
    const hosts = [...document.querySelectorAll('[data-mf-tassen-designer-host]')];
    hosts.forEach(host => {
      host.dataset.mfMugMode = 'metallic';
      host.dataset.mfMetallicBootstrap = '20260826-v7';
    });
    return hosts;
  };

  const load = (name, done) => {
    const script = document.createElement('script');
    const url = new URL(name, base);
    url.searchParams.set('mfv', '20260826-v7');
    script.src = url.href;
    script.async = false;
    if (done) script.onload = done;
    script.onerror = error => console.error('[MF Metallic]', name, error);
    (document.head || document.documentElement).appendChild(script);
  };

  const start = () => {
    if (started) return;
    tries += 1;
    const hosts = markMetallicHosts();
    if (!hosts.length) {
      if (tries < 80) setTimeout(start, 50);
      return;
    }

    started = true;
    load('mf-tassen-metallic-mode-backup-v4.js', () => {
      markMetallicHosts();
      load('mf-tassen-metallic-preview-v6.js', () => {
        markMetallicHosts();
        document.querySelectorAll('[data-mf-tassen-designer-host]').forEach(host => {
          host.dispatchEvent(new CustomEvent('mf:mug-metallic-bootstrap', { detail: { version: '20260826-v7' } }));
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    start();
    document.addEventListener('DOMContentLoaded', () => {
      markMetallicHosts();
      start();
    }, { once: true });
  } else {
    start();
  }

  [100, 250, 600, 1200, 2500].forEach(ms => setTimeout(markMetallicHosts, ms));
})();
